import { render, staticRenderFns } from "./LastAction.vue?vue&type=template&id=1f619522&scoped=true"
import script from "./LastAction.vue?vue&type=script&lang=js"
export * from "./LastAction.vue?vue&type=script&lang=js"
import style0 from "./LastAction.vue?vue&type=style&index=0&id=1f619522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f619522",
  null
  
)

export default component.exports